import { z } from 'zod';
export const projectsProjectAccessDecisionV1Capability = 'projects.project-access-decision.v1';
export const projectsProjectAccessDecisionCapability = 'projects.project-access-decision.v2';
export const projectsProjectAccessV1BasisSchema = z.enum([
    'assigned',
    'manage-all',
    'read-only',
    'legacy-unknown',
]);
export const projectsProjectAccessBasisSchema = z.enum([
    'assigned',
    'manage-all',
]);
export const projectsProjectAccessDecisionV1Schema = z.strictObject({
    contractVersion: z.literal(projectsProjectAccessDecisionV1Capability),
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(500),
    projectRevision: z.number().int().positive(),
    accessBasis: projectsProjectAccessV1BasisSchema,
    canWrite: z.boolean(),
    assignmentOverrideRequired: z.boolean(),
}).superRefine((decision, context) => {
    const expectedCanWrite = decision.accessBasis === 'assigned' || decision.accessBasis === 'manage-all';
    if (decision.canWrite !== expectedCanWrite) {
        context.addIssue({
            code: 'custom',
            path: ['canWrite'],
            message: 'Project access decision canWrite must match the access basis.',
        });
    }
    if (decision.assignmentOverrideRequired !== (decision.accessBasis === 'read-only')) {
        context.addIssue({
            code: 'custom',
            path: ['assignmentOverrideRequired'],
            message: 'Project assignment override is required only for read-only Project access.',
        });
    }
});
export const projectsProjectAccessDecisionV2Schema = z.strictObject({
    contractVersion: z.literal(projectsProjectAccessDecisionCapability),
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(500),
    projectRevision: z.number().int().positive(),
    accessBasis: projectsProjectAccessBasisSchema,
    canRead: z.literal(true),
    canWrite: z.literal(true),
    assignmentOverrideRequired: z.literal(false),
    requiresCurrentServerValidation: z.literal(true),
});
/**
 * Historical owner snapshots remain readable, but only v2 is a current
 * authorization decision. A retained/offline v1 or v2 snapshot is evidence,
 * never authority: every server action must resolve v2 again.
 */
export const projectsProjectAccessDecisionSchema = z.discriminatedUnion('contractVersion', [
    projectsProjectAccessDecisionV1Schema,
    projectsProjectAccessDecisionV2Schema,
]);
//# sourceMappingURL=projects-project-access-decision.contract.js.map